import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Dialog from '@/design_system/Dialog';
import { Footer, FooterButtons } from '@/design_system/Footer';
import Paragraph from '@/design_system/Typography/Paragraph';

export const DiscardChangesDialog = ({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  return (
    <Dialog
      isOpen
      onOpenChange={onCancel}
      title={<Trans id="dialog.discard-changes.title">Discard changes</Trans>}
      style={{ maxWidth: '25rem' }}
    >
      <main>
        <Paragraph>
          <Trans id="dialog.discard-changes.content">
            You're about to leave this page without saving your changes. All unsaved changes will be
            lost.
            <br />
            Are you sure?
          </Trans>
        </Paragraph>
      </main>
      <Footer>
        <FooterButtons>
          <Button variant="secondary" size="medium" onPress={onCancel}>
            <Trans id="dialog.discard-changes.cancel">Cancel</Trans>
          </Button>
          <Button variant="danger" size="medium" onPress={onConfirm}>
            <Trans id="dialog.discard-changes.confirm">Discard changes</Trans>
          </Button>
        </FooterButtons>
      </Footer>
    </Dialog>
  );
};
